import { render, staticRenderFns } from "./PostListing.vue?vue&type=template&id=2f3d45f2&scoped=true"
import script from "./PostListing.vue?vue&type=script&lang=js"
export * from "./PostListing.vue?vue&type=script&lang=js"
import style0 from "./PostListing.vue?vue&type=style&index=0&id=2f3d45f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3d45f2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PostListing.vue
// module id = 294
// module chunks = 0